import { render } from "./Umrah_trips.vue?vue&type=template&id=1dac4742&scoped=true"
import script from "./Umrah_trips.vue?vue&type=script&lang=js"
export * from "./Umrah_trips.vue?vue&type=script&lang=js"

import "./Umrah_trips.vue?vue&type=style&index=0&id=1dac4742&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dac4742"]])

export default __exports__